import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';
import { UserConstant } from 'src/app/shared/constants/user-constant';

@Component({
  selector: 'app-organization-model',
  templateUrl: './organization-model.component.html',
  styleUrls: ['./organization-model.component.scss']
})
export class OrganizationModelComponent implements OnInit {
  deviceForm: FormGroup;
  submitted = false;
  getdeviceArray = [];
  device = [];
  filteredOrg = [];
  dlgData: any;
  orgId: any;
  role: any;
  domain: any;
  selected: any;
  searchOrgPipe: any;
  roleShow:boolean = false;
  userRole: any;

  @ViewChild('orginput') searchElement: ElementRef;

  orgType = [{
    name: "Master MSP",
    id: 1
  },
  {
    name: "MSP",
    id: 2
  },
  {
    name: "Organization",
    id: 3
  }
  ]
  selectedRole: any;
  organizationId: any;
  currentUserOrganization: any;
  allowAllLoginSources = true;
  loginAclEnabled = false;
  canSetLoginAcl = false;

  constructor(private formBuilder: FormBuilder, public userService: UserService, private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<OrganizationModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    let storedUser = localStorage.getItem(UserConstant.USER);
    storedUser = JSON.parse(storedUser);
    this.userRole = storedUser['role'];
    this.organizationId = storedUser['_id'];
    this.currentUserOrganization = storedUser['organization'];
    
    this.domain = this.data.domain;
    if (this.data && this.data._id) {
      this.dlgData = this.data;
      this.orgId = this.dlgData._id;
    }
    this.role = this.data.role;
    this.deviceForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      parent: new FormControl(null, []),
      domain: new FormControl('', [Validators.required]),
      role: new FormControl(null, [Validators.required]),
      loginAclEnabled: new FormControl(false),
      loginAclAllowedCidrs: new FormControl('', [this.loginAclCidrsValidator.bind(this)]),
      loginAclDeniedCidrs: new FormControl('', [this.loginAclCidrsValidator.bind(this)]),

    });

    if (this.orgId) {
      this.deviceForm.controls.name.setValue(this.dlgData.name);
      this.deviceForm.controls.domain.setValue(this.dlgData.domain);
      this.applyLoginAcl(this.dlgData);
    }

    this.userService.getOrganization({id: this.currentUserOrganization}).subscribe(res => {
      this.canSetLoginAcl = this.isMspAdminOrAbove(this.userRole, res.data[0]?.role);
    })

    this.userService.getOrganization({id: this.orgId}).subscribe(res => {
      let filterOrg = this.getDomainOrg(res.data[0]);
      this.filteredOrg = filterOrg.filter(o => o.role <=2)

      this.selected = this.domain._id
      
      if(this.role == 3){
        this.roleShow = false;
      } else {
        this.roleShow = true;
        if(this.role == 2){
          this.selectedRole = 3;
        } else if(this.role == 1){
          this.selectedRole = 2;
        } else if(this.role == 0){
          this.selectedRole = 1;
        }
      }
    })
  }

  searchFocus() {
    setTimeout(()=>{ 
      this.searchElement.nativeElement.focus();
    },50);
  }

  onOrgChange(event) {
    let org = this.filteredOrg.find(o => o._id == event.value)
    this.role = org.role

    if(this.role == 3){
        this.roleShow = false;
      } else {
        this.roleShow = true;
        if(this.role == 2){
          this.selectedRole = 3;
        } else if(this.role == 1){
          this.selectedRole = 2;
        } else if(this.role == 0){
          this.selectedRole = 1;
        }
      }
  }

  getDomainOrg(domain) {
    let filtered = [];
    filtered.push(domain)
    for (let i = 0; i < domain.subOrganizations.length; i++) {
      let org = domain.subOrganizations[i];
      filtered = [...filtered, ...this.getDomainOrg(org)]
    }
    return filtered;
  }

  applyLoginAcl(org) {
    const loginAcl = org.loginAcl || {};
    const allowedCidrs = loginAcl.allowedCidrs || loginAcl.sourceIps || org.loginAclSourceIps || org.allowedLoginSourceIps || [];
    const deniedCidrs = loginAcl.deniedCidrs || org.loginAclDeniedCidrs || [];
    const allowedEntries = Array.isArray(allowedCidrs) ? allowedCidrs : this.normalizeLoginAclCidrs(allowedCidrs);
    const deniedEntries = Array.isArray(deniedCidrs) ? deniedCidrs : this.normalizeLoginAclCidrs(deniedCidrs);
    const enabled = loginAcl.enabled || org.loginAclEnabled || allowedEntries.length || deniedEntries.length || false;

    this.allowAllLoginSources = !enabled;
    this.loginAclEnabled = enabled;
    this.deviceForm.controls.loginAclEnabled.setValue(enabled);
    this.deviceForm.controls.loginAclAllowedCidrs.setValue(allowedEntries.join('\n'));
    this.deviceForm.controls.loginAclDeniedCidrs.setValue(deniedEntries.join('\n'));
  }

  isMspAdminOrAbove(userRole, orgRole) {
    const normalizedUserRole = Number(userRole);
    const normalizedOrgRole = Number(orgRole);

    if (!Number.isFinite(normalizedUserRole)) {
      return false;
    }

    if (Number.isFinite(normalizedOrgRole)) {
      return normalizedOrgRole <= 2 && normalizedUserRole <= 2;
    }

    return normalizedUserRole <= 2;
  }

  normalizeLoginAclCidrs(value) {
    if (!value) {
      return [];
    }
    return value.split(/[\n,]+/)
      .map(ip => ip.trim())
      .filter(ip => ip.length);
  }

  isValidLoginAclCidr(value) {
    const parts = value.split('/');
    if (parts.length > 2) {
      return false;
    }

    if (parts.length === 2) {
      const prefix = Number(parts[1]);
      if (!Number.isInteger(prefix) || prefix < 0 || prefix > 32) {
        return false;
      }
    }

    const octets = parts[0].split('.');
    if (octets.length !== 4) {
      return false;
    }

    return octets.every(octet => {
      if (!/^\d{1,3}$/.test(octet)) {
        return false;
      }
      const value = Number(octet);
      return value >= 0 && value <= 255;
    });
  }

  loginAclCidrsValidator(control: FormControl) {
    const entries = this.normalizeLoginAclCidrs(control.value);
    if (!entries.length) {
      return null;
    }
    return entries.every(entry => this.isValidLoginAclCidr(entry)) ? null : { loginAclCidrs: true };
  }

  onAllowAllLoginSourcesChange(event) {
    this.allowAllLoginSources = event.checked;
    this.loginAclEnabled = !event.checked;
    this.deviceForm.controls.loginAclEnabled.setValue(this.loginAclEnabled);

    if (event.checked) {
      this.deviceForm.controls.loginAclAllowedCidrs.setValue('');
      this.deviceForm.controls.loginAclDeniedCidrs.setValue('');
    }
  }

  onLoginAclCidrsInput() {
    const allowedCidrs = this.normalizeLoginAclCidrs(this.deviceForm.get('loginAclAllowedCidrs').value);
    const deniedCidrs = this.normalizeLoginAclCidrs(this.deviceForm.get('loginAclDeniedCidrs').value);

    if (allowedCidrs.length || deniedCidrs.length) {
      this.allowAllLoginSources = false;
      this.loginAclEnabled = true;
      this.deviceForm.controls.loginAclEnabled.setValue(true);
    }
  }

  getLoginAclPayload() {
    const enabled = !this.allowAllLoginSources;
    const allowedCidrs = this.normalizeLoginAclCidrs(this.deviceForm.get('loginAclAllowedCidrs').value);
    const deniedCidrs = this.normalizeLoginAclCidrs(this.deviceForm.get('loginAclDeniedCidrs').value);

    if (enabled && !allowedCidrs.length && !deniedCidrs.length) {
      this.toastr.warning('Add at least one allowed or denied login CIDR.');
      return null;
    }

    return {
      enabled,
      allowedCidrs,
      deniedCidrs
    };
  }

  getSavedOrgId(res) {
    return this.orgId ||
      res?._id ||
      res?.id ||
      res?.orgRecord?._id ||
      res?.orgRecord?.id ||
      res?.data?._id ||
      res?.data?.id ||
      res?.data?.orgRecord?._id ||
      res?.data?.orgRecord?.id ||
      res?.data?.[0]?._id ||
      res?.data?.[0]?.id;
  }

  saveLoginAcl(orgId, onSuccess) {
    if (!this.canSetLoginAcl) {
      onSuccess();
      return;
    }

    const loginAcl = this.getLoginAclPayload();
    if (!loginAcl) {
      this.submitted = false;
      return;
    }

    if (!orgId) {
      this.submitted = false;
      this.toastr.error('Organization saved, but login ACL could not be saved because the organization id was missing.');
      return;
    }

    this.userService.setOrganizationLoginAcl(orgId, loginAcl).subscribe(res => {
      onSuccess();
    }, (error => {
      this.submitted = false;
      this.toastr.error(error.error.error);
    }));
  }

  onSubmit() {
    if (this.submitted) return;
    // stop here if form is invalid
    if (this.deviceForm.invalid) {

      return;
    } else {
      let name = this.deviceForm.get('name').value;
      let parent = this.deviceForm.get('parent').value;
      let domain = this.deviceForm.get('domain').value;
      let role = this.deviceForm.get('role').value;
      const postObject = {
        name: name,
        parentOrg: parent,
        domain: domain,
        role: role,
      };

      if (this.orgId) {
        postObject['_id'] = this.orgId;
        
      }
      this.submitted = true;
      this.userService.createOrganization(postObject).subscribe(res => {
        const orgId = this.getSavedOrgId(res);
        this.saveLoginAcl(orgId, () => {
          this.submitted = false;
          this.toastr.success(' Organization Created Successfully!');
          this.dialogRef.close();
        });
      }, (error => {
        this.submitted = false;
        this.toastr.error(error.error.error);
      }));
    }
  }
}
